import { useI18n } from '../../i18n';

/** #631 — the "Show more (20 of 359)" button under a list that shows its rows
 *  one page at a time. The list keeps the count; the button adds a page. */
export default function ShowMoreButton({ shown, total, onMore, testId }: { shown: number; total: number; onMore: () => void; testId: string }) {
  const { t } = useI18n();
  if (total <= shown) return null;
  return (
    <div className="p-3 border-t border-gray-100 text-center">
      <button type="button" onClick={onMore} data-testid={testId} className="btn-outline btn-sm">
        {t.athletes.showMore.replace('{shown}', String(shown)).replace('{total}', String(total))}
      </button>
    </div>
  );
}
